import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "task-transfer-modal" }
const _hoisted_2 = { class: "task-transfer-modal_queues" }
const _hoisted_3 = { class: "task-transfer-modal_queues_header" }
const _hoisted_4 = { class: "task-transfer-modal_panel-namespaces-block" }
const _hoisted_5 = { class: "task-transfer-modal_project-info" }
const _hoisted_6 = {
  key: 0,
  class: "task-transfer-modal_panel-skeleton"
}
const _hoisted_7 = { class: "task-transfer-modal_queue-info--radio-block" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "task-transfer-modal_no-find-data no-find-queues" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Данные не найдены", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "task-transfer-modal_no-find-data" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "Данные не найдены", -1)

import { ChooseProjectDropdown, EditQueueModal } from '@/components';
import { ProjectModel } from '@/models';
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmModal,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPopover,
  TirPmRadio,
  TirPmScrollbar,
  TirPmSkeletonLoader,
  TirPmSvg,
} from 'tir-components';
import { TirPmSearchInput } from 'tir-pm-search-input';
import { computed, onMounted, ref, watch } from 'vue';
import {
  BaseProjectResponse,
  GetListByProjectIdRequest,
  PageRequest,
  ProjectNamespaceListItem,
  ProjectNamespaceListRequest,
  ProjectSearchRequest,
  QueueModel,
} from './models';
import { AdapterService } from './adapter-service';
import { debounce } from 'tir-pm-debounce';
import { useRouter } from 'vue-router';
import { ListBulletIcon, QuestionMarkCircleIcon } from 'tir-style-system/icons/outline';
import TaskMoveRequestModel from '../task-drawer/models/TaskMoveRequestModel';
import { TirPmFoldPanel } from 'tir-pm-fold-panel';
import GetListStatusRequestModel from './models/GetListStatusRequestModel';
import GetListStatusResponseItemModel from './models/GetListStatusResponseItemModel';
import { StatusParameter } from './components';

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-transfer-modal',
  props: {
  /**id проекта */
  projectId: { type: Number, required: true },
  /**Id задачи */
  taskId: { type: Number },
  /**есть ли родительская задача */
  isParentalTask: { type: Boolean },
  /**Прикрепленные очереди */
  attachedQueues: { type: Boolean },
  /**наличие подзадач */
  isSubtasks: { type: Boolean },
},
  emits: ["showSettingsTask", "transferTask"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const router = useRouter();
/**API сервис */
const apiService = new AdapterService();

/**Параметры */

/**События */


/**Открыто ли окно */
const visible = ref(false);
/**Выбранный проект */
const project = ref<ProjectModel>();
/**Поисковой запрос */
const search = ref('');
/**Поиск по НС */
const searchNamespace = ref('');
/**Поиск по очередям */
const searchQueue = ref('');
/**Количество очередей */
const queuesCount = ref();
/**Список очередей */
const queues = ref<QueueModel[]>();
/**Происходит загрузка */
const isLoadingId = ref();
/**Загрузка очередей */
const isLoadingQueueId = ref();
/**ID задачи */
const taskId = ref<number>();
/**Редактируемая очередь */
const editQueue = ref();
/**Список рабочих областей */
const namespaces = ref<ProjectNamespaceListItem[]>([]);
/**id раскрытого НС */
const openedNamespaceId = ref<string>();
/**Общ. кол-во НС */
const namespaceTotalCount = ref<number>();
/**Выбранная очередь */
const selectedQueue = ref<QueueModel>();
/**Список статусов выбранной очереди */
const statusesList = ref<GetListStatusResponseItemModel[]>();
/**Загрузка статусов */
const isLoadingStatus = ref();

/**После рендера компонента */
onMounted(async () => {
  await getNamespace();
});

/**Пагинация */
const pageRequest = computed(() => ({
  Skip: 0,
  Take: 15,
}));

/**Переключение видимости окна */
const toggle = (_visible: boolean, _taskId?: number) => {
  visible.value = _visible;
  taskId.value = _taskId;
  openedNamespaceId.value = null;
  selectedQueue.value = null;

  if (!_visible) {
    resetQueues();
    searchNamespace.value = '';
    searchQueue.value = '';
    project.value = undefined;
  }
};
/**Переключение видимости панели НС */
const toggleVisiblePanelNamespace = async (namespaceId: string) => {
  openedNamespaceId.value = openedNamespaceId.value === namespaceId ? null : namespaceId;
  if (openedNamespaceId.value === namespaceId) await getQueues();
};
/**Получить рабочие области */
const getNamespace = async () => {
  const response = await apiService.getNamespaces(
    new ProjectNamespaceListRequest({
      ProjectId: props.projectId,
      Search: searchNamespace.value,
      Page: new PageRequest(pageRequest.value),
    }),
  );
  if (response.IsSuccess) {
    namespaces.value = response.Value.Items;
  }
  isLoadingId.value = null;
};
/**Получить список следующих рабочих областей */
const getNextNamespace = async () => {
  const response = await apiService.getNamespaces(
    new ProjectNamespaceListRequest({
      ProjectId: props.projectId,
      Search: searchNamespace.value,
      Page: new PageRequest({
        Skip: namespaces.value.length,
        Take: pageRequest.value.Take,
      }),
    }),
  );
  if (response.IsSuccess) {
    namespaces.value.push(...response.Value.Items);
    namespaceTotalCount.value = response.Value.Page.Count;
  }
  isLoadingId.value = null;
};
/**Отсроченное получение проекта */
const debounceSearchNamespaces = debounce(getNamespace, 500);

/**Получение очередей */
async function getQueues() {
  if (!openedNamespaceId.value) return;
  isLoadingQueueId.value = openedNamespaceId.value;
  const response = await apiService.getQueues(
    new GetListByProjectIdRequest({
      ProjectId: props.projectId,
      NamespaceId: openedNamespaceId.value,
      Search: searchQueue.value,
      Page: pageRequest.value,
    }),
  );
  if (response.IsSuccess) {
    queues.value = response.Items;
    queuesCount.value = response.Count;
  }
  isLoadingQueueId.value = null;
}
/**Отсроченное получение проекта */
const debounceSearchQueue = debounce(getQueues, 500);
/**Сброс текущих очередей */
const resetQueues = () => {
  queues.value = [];
  queuesCount.value = undefined;
};
/**Перенос тикета */
const transferTask = async (queue: QueueModel, _statusId: number) => {
  let res = await apiService.taskMove(
    new TaskMoveRequestModel({
      TaskId: props.taskId,
      NewQueueTaskId: selectedQueue.value.Id,
      StatusId: _statusId,
    }),
  );
  if (res.IsSuccess) {
    router.push({
      name: 'queue',
      params: {
        projectId: props.projectId,
        queueId: selectedQueue.value.Id,
        namespaceId: queue.NamespaceId,
      },
    });
    addNotification('Успешный перенос тикета', false, 5000);
    visible.value = false;
    emit('transferTask');
  } else {
    addNotification(res.ErrorMessage, true, 5000);
  }
};
/**При скроле спика нс */
const onScrollNamespaceList = async (data: Event) => {
  const el = data.target as HTMLElement;
  const reachedBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;

  if (reachedBottom && namespaceTotalCount.value !== namespaces.value.length) {
    await getNextNamespace();
  }
};

/**Получить статусы очереди */
const getStatusesQueue = async () => {
  isLoadingStatus.value = true;
  const response = await apiService.getStatusesListDetail(
    new GetListStatusRequestModel({
      QueueTasksId: [selectedQueue.value.Id],
    }),
  );
  if (response.IsSuccess) {
    statusesList.value = response.Value.Items;
  }
  isLoadingStatus.value = false;
};
/**Открытая панель НС */
const openPanelNamespace = (namespaceId: string) => {
  return openedNamespaceId.value === namespaceId;
};
/**Выбрать очередь */
const selectQueue = (queue: QueueModel) => {
  selectedQueue.value = queue;
};
/**Закрыть окно редактирования очереди */
const closeEditQueueModal = async () => {
  editQueue.value = null;
  resetQueues();
  await getQueues();
};

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**Код для использования по ref */
__expose({ toggle });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmModal), {
      ref: "$modal",
      classes: "task-transfer-modal_window",
      "is-close-overlay": "",
      title: `Перенос тикета #${props.taskId}`,
      "is-with-back": false,
      "is-visible": visible.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (toggle(false)))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!openedNamespaceId.value)
                ? (_openBlock(), _createBlock(_unref(TirPmSearchInput), {
                    key: 0,
                    class: "task-transfer-modal_search",
                    modelValue: searchNamespace.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((searchNamespace).value = $event)),
                      _unref(debounceSearchNamespaces)
                    ],
                    placeholder: "",
                    label: "Поиск по рабочим областям",
                    "is-with-popup": false
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : (_openBlock(), _createBlock(_unref(TirPmSearchInput), {
                    key: 1,
                    class: "task-transfer-modal_search",
                    modelValue: searchQueue.value,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((searchQueue).value = $event)),
                      _unref(debounceSearchQueue)
                    ],
                    placeholder: "",
                    label: "Поиск по очередям",
                    "is-with-popup": false
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            ]),
            _createVNode(_unref(TirPmScrollbar), {
              class: "task-transfer-modal_scrollbar",
              showOnHover: "",
              onOnScroll: onScrollNamespaceList
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(namespaces.value, (namespace) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: namespace.Id
                    }, [
                      _createVNode(_unref(TirPmFoldPanel), {
                        isVisible: openPanelNamespace(namespace.Id),
                        onToggle: ($event: any) => (toggleVisiblePanelNamespace(namespace.Id)),
                        class: "task-transfer-modal_panel-namespaces task-transfer-modal_panel"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(TirPmSvg), {
                              class: "task-transfer-modal_namespace-icon",
                              url: namespace.IconUrl,
                              color: namespace.Color
                            }, null, 8, ["url", "color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["task-transfer-modal_project-name", { 'fold-panel--active': openPanelNamespace(namespace.Id) }])
                            }, _toDisplayString(namespace.Name), 3)
                          ])
                        ]),
                        content: _withCtx(() => [
                          (isLoadingQueueId.value === namespace.Id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(_unref(TirPmSkeletonLoader), {
                                  width: "100%",
                                  height: "2.5rem",
                                  borderRadius: "62.4375rem"
                                }),
                                _createVNode(_unref(TirPmSkeletonLoader), {
                                  width: "100%",
                                  height: "2.5rem",
                                  borderRadius: "62.4375rem"
                                })
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(queues.value, (queue) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: queue.Id,
                                  class: "task-transfer-modal_queue-info"
                                }, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(TirPmRadio), {
                                      value: 1,
                                      "model-value": selectedQueue.value?.Id === queue.Id ? 1 : 0,
                                      "onUpdate:modelValue": ($event: any) => (selectQueue(queue))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                    _createVNode(_unref(ListBulletIcon), { class: "task-transfer-modal_icon" })
                                  ]),
                                  _createElementVNode("div", null, _toDisplayString(queue.Name), 1)
                                ]))
                              }), 128)),
                          (!queues.value?.length && !isLoadingQueueId.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_unref(TirPmIconView), {
                                    size: 24,
                                    isBordered: false
                                  }, {
                                    mainSlot: _withCtx(() => [
                                      _createVNode(_unref(QuestionMarkCircleIcon))
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_10
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["isVisible", "onToggle"])
                    ]))
                  }), 128)),
                  (!namespaces.value.length && !isLoadingId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_unref(TirPmIconView), {
                            size: 24,
                            isBordered: false
                          }, {
                            mainSlot: _withCtx(() => [
                              _createVNode(_unref(QuestionMarkCircleIcon))
                            ]),
                            _: 1
                          }),
                          _hoisted_13
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(TirPmPopover), {
          customPosition: { left: '0rem', top: 'unset' },
          isNoTeleport: "",
          isDisabled: !selectedQueue.value,
          class: "task-transfer-modal_popover"
        }, {
          content: _withCtx(() => [
            _createVNode(_unref(TirPmScrollbar), {
              class: "task-transfer-modal_scrollbar-status-list",
              showOnHover: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusesList.value, (status) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: status.Id
                  }, [
                    _createVNode(_unref(StatusParameter), {
                      options: status,
                      onSelectStatus: ($event: any) => (transferTask(selectedQueue.value, status.Id))
                    }, null, 8, ["options", "onSelectStatus"])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).PrimaryState,
              size: _unref(TirPmButtonSizeEnum).Regular,
              isDisabled: !selectedQueue.value,
              onClick: getStatusesQueue
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Выбрать статус и завершить перенос ")
              ]),
              _: 1
            }, 8, ["variant", "size", "isDisabled"])
          ]),
          _: 1
        }, 8, ["isDisabled"])
      ]),
      _: 1
    }, 8, ["title", "is-visible"]),
    _createVNode(_unref(EditQueueModal), {
      queue: editQueue.value,
      onClose: closeEditQueueModal
    }, null, 8, ["queue"])
  ], 64))
}
}

})